import Navbar from './components/navbar';
import ScrollProgress from './components/scrollProgress';
import Home from './pages/home';
import About from './pages/about';
import Skills from './pages/skills';
import Experience from './pages/experience';
import Projects from './pages/projects';
import Credentials from './pages/credentials';
import Github from './pages/github';
import Contact from './pages/contact';
import Footer from './components/footer';
import useTheme from './hooks/useTheme';

function App() {
  const { theme, toggle } = useTheme();

  return (
    <>
      <ScrollProgress />
      <Navbar theme={theme} toggleTheme={toggle} />
      <Home />
      <About />
      <Skills />
      <Experience />
      <Projects />
      <Credentials />
      <Github />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
